import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KnowledgeAreaCard } from './knowledge-area-card';
import type { KnowledgeArea } from '@/models/bootstrap/taxonomy';

export const CustomGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: 0,
  gridTemplateColumns: '1fr',
  borderLeftColor: theme.palette.neutral[300],
  borderLeftStyle: 'solid',
  borderLeftWidth: 1,
  borderTopColor: theme.palette.neutral[300],
  borderTopStyle: 'solid',
  borderTopWidth: 1,
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(6, 1fr)',
  },
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: 'repeat(8, 1fr)',
  },
}));

export const KnowledgeAreaList = ({
  data,
}: {
  data: (KnowledgeArea & { link: string })[];
}) => (
  <Grid container spacing={2} columns={{ xs: 2, md: 4, lg: 6 }}>
    {data.map((knowledgeArea) => (
      <Grid size={1} key={`knowledge-area-${knowledgeArea.id}`}>
        <KnowledgeAreaCard data={knowledgeArea} />
      </Grid>
    ))}
  </Grid>
);
